import PanelContainer from "../../lib/panel/panel-container";
import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import {
  FloatingPanelContent,
  FloatingPanelSeparator,
} from "@babackapp/ui/components/floating-panel";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@babackapp/ui/components/tabs";
import { DoubleButtonsBlockProps } from "./types";
import { EmailPanelLabel } from "../button/email-panel-label";
import { EmailPanelUrl } from "../button/email-panel-url";
import { EmailPanelStyle } from "../button/email-panel-style";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { useTranslation } from "react-i18next";
import PanelBlockFont from "../../lib/panel/panel-block-font";

export function DoubleButtonsEmailPanelRenderer(
  blockProps: DoubleButtonsBlockProps,
) {
  const { t } = useTranslation("editor-blocks-library");

  return (
    <PanelContainer blockProps={blockProps}>
      <Tabs defaultValue="button0" className="w-full">
        <FloatingPanelContent className="pb-0">
          <TabsList className="w-full flex">
            <TabsTrigger className="flex-1" value="button0">
              {t(
                "editorBlocksLibrary.blocks.double-buttons.panel.button1.title",
                "Button 1",
              )}
            </TabsTrigger>
            <TabsTrigger className="flex-1" value="button1">
              {t(
                "editorBlocksLibrary.blocks.double-buttons.panel.button2.title",
                "Button 2",
              )}
            </TabsTrigger>
          </TabsList>
        </FloatingPanelContent>
        <FloatingPanelSeparator />
        <TabsContent value="button0" className="flex flex-col gap-0 pt-0">
          <EmailPanelLabel buttonKey="button0" />
          <FloatingPanelSeparator />
          <EmailPanelUrl buttonKey="button0" />
          <FloatingPanelSeparator />
          <EmailPanelStyle variantFieldName="button0Variant" />
        </TabsContent>
        <TabsContent value="button1" className="flex flex-col gap-0 pt-0">
          <EmailPanelLabel buttonKey="button1" />
          <FloatingPanelSeparator />
          <EmailPanelUrl buttonKey="button1" />
          <FloatingPanelSeparator />
          <EmailPanelStyle variantFieldName="button1Variant" />
        </TabsContent>
      </Tabs>
      <FloatingPanelSeparator />
      <PanelBlockFont />
      <PanelBlockAlignment />
      <PanelTranslationState mode="translatable" portal />
    </PanelContainer>
  );
}
